<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a><a id="pv"></a><a id="pvi"></a>
<p class="center ">Copyright © 1994 R.C.S. Libri &amp; Grandi Opere SpA-Milano</p>
<p class="center ">English translation copyright © 1995 by Houghton Mifflin Harcourt</p>
<p class="center spaceabove1">All rights reserved. For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1">
<a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a>
</p>
<p class="center spaceabove1">This is a translation of <em>L’Isola del Giorno Prima.</em></p>
<p class="center spaceabove1">The Library of Congress has cataloged the hardcover edition as follows:</p>
<p class="center ">Eco, Umberto.<br/>
[Isola del giorno prima. English]<br/>
The island of the day before/by Umberto Eco;<br/>
translated from the Italian by William Weaver.—1st ed.<br/>
p. cm.</p>
<p class="center ">I. Weaver, William, 1923– . II. Title.</p>
<p class="center ">PQ4865.C6I8413 1995<br/>
853'.914—dc20 95-7594</p>
<p class="center ">ISBN-13: 978-0-15-100151-4 ISBN-10: 0-15-100151-0</p>
<p class="center ">ISBN-13: 978-0-15-603037-3 (pbk.) ISBN-10: 0-15-603037-3 (pbk.)</p>
<p class="center spaceabove1">eISBN 978-0-547-56389-3<br/>
v2.0620</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?44ed9828